import api from 'shared/api';
import { licenseResetOptions } from 'shared/constants';
import {
  hasResetMaintenancePeriod,
  hasResetValidityPeriod,
  isConsumptionLicense,
} from 'shared/helpers';

const getResetLicensePayload = (license, options = {}) => {
  const resetOptions = {
    ...licenseResetOptions,
    ...options,
  };

  const payload = {};

  if (hasResetValidityPeriod(license)) {
    payload.reset_validity_period = resetOptions.reset_validity_period;
  }

  if (hasResetMaintenancePeriod(license)) {
    payload.reset_maintenance_period = resetOptions.reset_maintenance_period;
  }

  if (isConsumptionLicense(license)) {
    payload.reset_consumptions = resetOptions.reset_consumptions;
  }

  return payload;
};

export const resetLicense = (licenseId, license, options = {}) => {
  const url = `/api/v1/licenses/${licenseId}/reset/`;
  return api.post(url, getResetLicensePayload(license, options));
};
